<template>
  <div class="loop_banner_container">
    <div class="loop_banner">
      <ul v-for="n in 2" :key="n" :aria-hidden="n === 2">
        <li v-for="(word, index) in games" :key="`${n}-${index}`">
          <img :src="word" alt="tool_image" class="tool_image" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const games = ref([
  "/images/games/league-of-legends-boost/game_icon.webp",
  "/images/games/valorant-boost/game_icon.webp",
  "/images/games/rainbow-six-siege-boost/game_icon.webp",
  "/images/games/rocket-league-boost/game_icon.webp",
  "/images/games/counter-strike-2-boost/game_icon.webp",
  "/images/games/dota-2-boost/game_icon.webp",
  "/images/games/apex-legends-boost/game_icon.webp",
  "/images/games/fortnite-boost/game_icon.webp",
  "/images/games/teamfight-tactics-boost/game_icon.webp",
  "/images/games/the-finals-boost/game_icon.webp",
  "/images/games/fc-boost/game_icon.webp",
  "/images/games/marvel-rivals-boost/game_icon.webp",
  "/images/games/path-of-exile-2-boost/game_icon.webp",
  "/images/games/gta-6-boost/game_icon.webp",
]);
</script>

<style lang="scss">
.loop_banner_container {
  max-width: 1080px;
  position: relative;

  &::after,
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 200px;
    z-index: 9;
  }

  &::after {
    left: 0;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.6) 20%,
      rgba(0, 0, 0, 0.3) 60%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  &::before {
    right: 0;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.6) 20%,
      rgba(0, 0, 0, 0.3) 60%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  @media screen and (max-width: 768px) {
    &::after,
    &::before {
      width: 50px;
    }
    width: calc(100% + 32px);
    left: -16px;
  }
}

.loop_banner {
  display: flex;
  width: 100%;
  overflow: hidden;
  user-select: none;
  gap: 16px;

  ul {
    display: flex;
    list-style: none;
    gap: 16px;
    animation: scroll-horizontal 40s linear infinite;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    li {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
}

.tool_image {
  width: 56px;
  height: 56px;
  object-fit: cover;

  @media screen and (max-width: 900px) {
    width: 48px;
    height: 48px;
  }
}
</style>
